import { FC } from 'react';
import useQueryParams from '@common/src/hooks/useQueryParams';
import { useAnvaQuotesV2Simple } from '@flows/src/api/anva-flows/getAnvaQuotesV2';
import { AnvaQuoteWithJob } from '@flows/src/types/anva';
import FlowProductsSidebar, {
  FlowProductsSidebarItem,
} from '@flows/src/components/flow-products/FlowProductsSidebar';

const FlowProductsAnvaSidebar: FC = () => {
  const queryParams = useQueryParams();
  const sessionId = queryParams.get('session_id') || undefined;
  const { data } = useAnvaQuotesV2Simple({
    sessionId,
    enabled: !!sessionId,
  });

  const sideBarItems =
    data?.quotes?.reduce(
      (uniqueItems: FlowProductsSidebarItem[], { tag }: AnvaQuoteWithJob) => {
        if (!uniqueItems.some((item) => item.key === tag.id.toString())) {
          uniqueItems.push({
            key: tag.id.toString(),
            label: tag.name,
            iconName: tag.icon_key,
          });
        }
        return uniqueItems;
      },
      [] as FlowProductsSidebarItem[],
    ) || [];
  return (
    <FlowProductsSidebar
      items={sideBarItems}
      isHidden={window.location.pathname.includes('selection-overview')}
    />
  );
};

export default FlowProductsAnvaSidebar;
